export const temporaryUUID = () => {
    // Using crypto.randomUUID() directly in the data structure causes issues with reactivity in Vue.
    // Prefixing with '_' to ensure it doesn't conflict with real UUIDs from the backend.
    return '_' + crypto.randomUUID();
};

export function removeTemporaryUUID<T, K extends string = string>(input: T, keys: readonly K[]): T {
    const keySet = new Set<PropertyKey>(keys);

    const walk = (val: unknown): unknown => {
        if (Array.isArray(val)) {
            return val.map(walk);
        }

        if (val !== null && typeof val === 'object') {
            const out: Record<string, unknown> = {};

            for (const [k, v] of Object.entries(val as Record<string, unknown>)) {
                if (keySet.has(k) && typeof v === 'string' && v.startsWith('_')) {
                    // Remove key
                    continue;
                }
                out[k] = walk(v);
            }

            return out;
        }

        return val;
    };

    return walk(input) as T;
}
